<div class="card card-custom card-stretch gutter-b" style="height: 100%;overflow-x: auto;">
  <div class="card card-custom card-stretch gutter-b" style="height: 90%;overflow-x: auto;">
  <div class="card-header align-items-center border-0 mt-4">
    <h4>Widget</h4>

    <dx-toolbar>
      <dxi-item location="before" widget="dxButton" locateInMenu="auto" [options]="backOptions">
      </dxi-item>
      <dxi-item location="before" widget="dxButton" [options]="deleteButtonOptions">
      </dxi-item>
      <dxi-item location="before" widget="dxButton" [options]="saveButtonOptions">
      </dxi-item>
    </dx-toolbar>
    <ng-container *ngIf="microApps.loadingObserver | async as _loading">
      <span class="spinner spinner-primary ml-5" aria-label="Cargando..."></span>
    </ng-container>
  </div>

  <div class="card-body pt-4">

    <div id="divMicroApp" class="micro-app-container" style="overflow-x: auto;">
      <dx-form *ngIf="microApploaded | async" [showColonAfterLabel]="false" colCount="4" [(formData)]="widgetdata"
        [showValidationSummary]="true" labelLocation="top">
        <!-- <dxi-item dataField="wid_cont">
        <dxo-label class="font-weight-bold" text="Código">
        </dxo-label>
        <dxi-validation-rule type="required" [message]="'Código Obligatorio'"></dxi-validation-rule>
    </dxi-item> -->

        <dxi-item dataField="wid_nomb">
          <dxo-label class="font-weight-bold" text="Nombre">
          </dxo-label>
          <dxi-validation-rule type="required" [message]="'Nombre Obligatorio'"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="wid_titl">
          <dxo-label class="font-weight-bold" text="Titulo">
          </dxo-label>
          <dxi-validation-rule type="required" [message]="'Titulo Obligatorio'"></dxi-validation-rule>
        </dxi-item>


        <dxi-item dataField="aud_esta">
          <dxo-label text="Estado" class="font-weight-bold"></dxo-label>
          <dx-select-box (onValueChanged)="onValueChangedSelectStatus($event)" [dataSource]="Status" displayExpr="name"
            [value]="widgetdata.aud_esta" valueExpr="id"></dx-select-box>
          <!-- <dxi-validation-rule type="required" [message]="'Titulo Obligatorio'"></dxi-validation-rule> -->
        </dxi-item>


        <!-- s -->

        <dxi-item dataField="wid_tiwd">
          <dxo-label text="Tipo Widget" class="font-weight-bold"></dxo-label>
          <dx-select-box (onValueChanged)="onValueChangedSelect($event)" [dataSource]="tipWid" displayExpr="name"
            [value]="widgetdata.wid_tiwd" valueExpr="id"></dx-select-box>
          <dxi-validation-rule type="required" [message]="'Tipo Widget Obligatorio'"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="wid_ssql" style="width: 950px;">
          <dxo-label text="Consulta" class="font-weight-bold"></dxo-label>
          <dx-text-area style="height: 150px;" [maxLength]="500" label="Consulta" [value]="widgetdata.wid_ssql"
            (onValueChanged)="onValueChangedtext($event)">
          </dx-text-area>
          <dxi-validation-rule type="required" [message]="'Consulta Obligatorio'"></dxi-validation-rule>
        </dxi-item>



      </dx-form>


      <div id="WidgetUser">

      

        <div class="widget-config-container" style="overflow-x: auto; width: 100%;">
          <div class="btn-load">
            <dx-button icon="add"  text="Agregar Usuario" (onClick)="qbeButtonuser()"
              style="margin-right: 10px;width: 10% !important; "></dx-button>
          </div>
            <dx-data-grid id="gridWidgetUser" style="width: 100%; min-width: 600px;"
                [dataSource]="UserList"
                [noDataText]="'Sin Widget'" 
                [columnHidingEnabled]="false"
                [columnAutoWidth]="true" 
                [showColumnLines]="true" 
                [showColumnHeaders]="true"
                [showRowLines]="true" 
                [showBorders]="true" 
                [rowAlternationEnabled]="true"
                (onRowRemoving)="onRowRemoving($event)"
                class="data-grid">
                
                <dxo-load-panel [enabled]="true"></dxo-load-panel>
                
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-paging [pageSize]="5"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true"></dxo-pager>
                <dxo-editing mode="cell" [allowUpdating]="false" [allowAdding]="false" [useIcons]="true" [allowDeleting]="true">
                  <dxo-texts deleteRow="Borrar fila" addRow="Añadir" cancelAllChanges="Cancelar cambios" editRow="Editar"
                  saveRowChanges="Guardar" cancelRowChanges="Cancelar"
                  confirmDeleteMessage="¿Está seguro de borrar este registro?">
               </dxo-texts>
                
                </dxo-editing>
             
                <dxi-column dataField="usu_codi" caption="Código de Usuario" [width]="250"></dxi-column>
                <dxi-column dataField="usu_nomb" caption="Nombre de Usuario" [width]="250"></dxi-column>
            </dx-data-grid>
        </div>

        <dx-popup title="Usuarios" [(visible)]="popupvisibleusuer" [closeOnOutsideClick]="true" [showCloseButton]="false"
          [showTitle]="true" [width]="1000" [height]="700">

          <dx-scroll-view width="90%" height="90%">
            <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
              <dx-data-grid #tableinstallationslist [noDataText]="'Sin datos'" (onRowDblClick)="onRowDblClick($event)"
                [dataSource]="UserListselect | async" [showColumnLines]="true" [showRowLines]="true" [showBorders]="true"
                [showColumnLines]="true" [showBorders]="true">
                <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true" [placeholder]="'Buscar'">
                </dxo-search-panel>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true">
                </dxo-pager>
                <dxi-column dataField="usu_codi" caption="Usuario"></dxi-column>
                <dxi-column dataField="usu_nomb" caption="Nombre Usuario"></dxi-column>
              </dx-data-grid>

            </dxi-item>
          </dx-scroll-view>
        </dx-popup>

      </div>
    </div>
  </div>
</div>
</div>